var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.2929 3.29289c.3905-.39052 1.0237-.39052 1.4142 0l6 6c.3905.39053.3905 1.02371 0 1.41421l-6 6c-.3905.3905-1.0237.3905-1.4142 0-.39053-.3905-.39053-1.0237 0-1.4142l4.2929-4.2929h-11.5858c-.55228 0-1-.4477-1-1 0-.55229.44772-1 1-1h11.5858l-4.2929-4.29289c-.39053-.39053-.39053-1.02369 0-1.41422z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.15d5337577985006c7d4209b9d1095c3.svg";
export { ForwardRef as ReactComponent };